import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../@shared/shared.module';
import { AuthGuard } from '../auth/guard';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { SwiperModule } from 'swiper/angular';

// import { LoginComponent } from './login/login.component';

@NgModule({
  declarations: [
    // LoginComponent,
    HomeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule,
    SharedModule,
    SwiperModule
  ],
  providers: [AuthGuard]
})
export class AuthModule { }
